import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import brad_logo from './../assets/img/brad-l.png';

export default class MobLoader extends Component {
	render() {
		return(<div>
				<div className="randomErrorBox">
					<div className="mobLoadingBox">
						<div style={{position: 'absolute',width: '80px', lineHeight: '80px', textAlign: 'center'}}><img src={brad_logo} style={{width: '40px'}} alt="bradman"/></div>
						<div><CircularProgress style={{ color:'#fff' }} size={80} thickness={2} /></div>
					</div>
				</div>
		</div>);
	}
}


// WEBPACK FOOTER //
// ./src/commons/MobLoader.js